<template>
  <v-application-view title="Cashbox">
    <v-layout row class="mx-2">
      <v-flex class="px-2 pt-2" md6 sm8 xs12>
        <v-card tile outlined>
          <v-card-text>
            <v-layout row class="px-2">
              <v-flex class="px-1"><v-text-field label="Amount" type="number" 
                  v-model="params.amount"/></v-flex>
              <v-flex class="px-1"><v-autocomplete label="Payment type" v-bind:items="payment_types"
                  v-model="params.type"/></v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <v-text-field label="Comment" prepend-inner-icon="mdi-comment-text"
              hint="Write a comment to understant order"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="success" outlined>
              Pay in
            </v-btn>
            <v-btn outlined color="success">
              Pay out
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application-view>
</template>
<script>
export default {
  name: 'Payment',
  data: () => ({
    payment_types: [
      {text: 'Cash', value: 'cash'},
      {text: 'Bank', value: 'bank'},
      {text: 'Credit card', value: 'card'},
    ],
    params: {
      type: 'cash',
      amount: null
    }
  })
}
</script>
